import Chip from "@mui/material/Chip"
import { styled } from "@mui/material/styles"

/** Small label for newly launched product areas. */
export default styled(Chip)(({ theme }) => ({
  height: 20,
  marginLeft: theme.spacing(1),
  fontSize: "0.65rem",
  fontWeight: 700,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.secondary.contrastText,
  "& .MuiChip-label": {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}))
